import React from "react";
import classNames from "classnames";
import { motion } from "framer-motion";
const titles = [
    "Step 1: Select your plan",
    "Step 2: Let us know about any allergies",
    "Step 3: Let us know your protein preference",
    "Step 4: Select initial menu",
    "Step 5: Additional restrictions",
    ""
];
const stepVariants = {
    initial: { opacity: 0, scale: 0.5, boxShadow: "non" },
    normal: { opacity: 1, scale: 1 },
    selected: { opacity: 1, scale: 1.2, boxShadow: "rgba(50, 50, 93, .3) 0px 6px 12px -2px, rgba(0, 0, 0, .3) 0px 3px 7px -3px" }
};
export default class MenuPlanNav extends React.Component {
    render() {
        const currentStep = (this.props.currentStep) || 1;
        return (React.createElement(React.Fragment, null,
            React.createElement("h1", { className: "text-center h2 animate__animated animate__faster animate__fadeIn" }, titles[currentStep - 1]),
            React.createElement(motion.div, { className: "wizard", initial: { opacity: 0, scale: 0.5 }, animate: { opacity: 1, scale: 1 } }, titles.map((title, idx) => (React.createElement(motion.div, { key: idx, className: classNames("step", {
                    "completed": (idx) === (currentStep - 1)
                }), variants: stepVariants, initial: "initial", animate: idx === (currentStep - 1) ? "selected" : "normal", transition: {
                    duration: 0.5,
                    delay: 0.1,
                    ease: [0, 0.71, 0.2, 1.01]
                } },
                React.createElement("span", null, idx + 1)))))));
    }
}
